import { defineMessages } from 'react-intl';

/**
 * Error messages used by the Calendar component for boundary validation.
 * These are distinct from the TimeframeSelector messages to provide
 * calendar-appropriate wording.
 * @internal
 */
export const CALENDAR_ERROR_MESSAGES = defineMessages({
  minBoundary: {
    id: '9XjoWQoeIKxStpgZ',
    defaultMessage: 'Please select a {term} later than {min}.',
    description:
      'Error message for a date or a timeframe earlier than the required minimum.',
  },
  maxBoundary: {
    id: '0Y8wN2jk+BAa2NoC',
    defaultMessage: 'Please select a {term} earlier than {max}.',
    description:
      'Error message for a date or a timeframe later then the expected maximum.',
  },
  minMaxBoundary: {
    id: 'LNWPcycjuDPimFKd',
    defaultMessage:
      'Please select a {term} within the range of {min} and {max}.',
    description:
      'Error message for a date or a timeframe outside the selectable range.',
  },
});
